import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Zap } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { analytics } from '@/utils/analytics';

export const ProHero: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleCTAClick = () => {
    analytics.trackEvent({
      action: 'click',
      category: 'engagement',
      label: 'pro_hero_cta',
      custom_parameters: {
        user_authenticated: isAuthenticated
      }
    });

    navigate(isAuthenticated ? '/dashboard' : '/auth?mode=signup');
  };

  return (
    <section className="bg-gradient-to-br from-blue-600 to-green-600 text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
  <a href="#scenarios" className="block group">
    <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-4 group-hover:underline decoration-white/60 underline-offset-4 cursor-pointer">
      Un client avec un DPE E/F/G ?{' '}
      <span className="block">Dites-lui exactement quoi faire. En 2 min.</span>
    </h1>
  </a>
  <p className="text-lg md:text-xl text-white/90 leading-relaxed">
  DPEWizard intègre un moteur de règles expert qui s'adapte précisément à chaque bien.<br />Il génère un scénario de travaux réaliste, le coût estimé et le gain de lettre.<br />Détaillé dans un PDF à vos couleurs.
</p>
</div>

            <div className="flex flex-wrap gap-4">
              <Button
                size="lg"
                className="bg-gray-900 text-white border-0 hover:bg-gray-800 shadow-lg hover:shadow-xl transition-all duration-200 px-8"
                onClick={handleCTAClick}
              >
                Analyser mon DPE maintenant (2021 et ultérieur)
              </Button>
            </div>

            <div className="flex items-center space-x-6 text-sm">
              <div className="flex items-center">
                <Shield className="w-5 h-5 mr-2" />
                <span>Données ADEME officielles</span>
              </div>
              <div className="flex items-center">
                <Zap className="w-5 h-5 mr-2" />
                <span>Analyse en 2 minutes</span>
              </div>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl shadow-2xl">
              <img
                src="/assets/DPEWizard_Hero_pro1.png"
                alt="DPEWizard Pro - Analyse de DPE pour professionnels"
                className="w-full h-auto rounded-lg"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProHero;
